import React from 'react';
import { UserProvider } from './contexts/UserContext';
import AppWithOnboarding from './components/AppWithOnboarding';
import ErrorBoundary from './components/ErrorBoundary';
import errorLogger from './utils/errorLogger';

function App() {
  return (
    <ErrorBoundary>
      <UserProvider>
        <AppWithOnboarding />
      </UserProvider>
    </ErrorBoundary>
  );
}

export default App;